import React, { useEffect } from "react";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import NextButton from "../components/NextButton";
import { setGroup } from "../redux/actions";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import finFelicidadesBg from "../assets/fin-felicidades.jpg";

function Congratulations({ intl }) {
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);

	useEffect(() => {
		if (group) {
			dispatch(
				setGroup({
					...group,
					lastVisited: ROUTES.RESULTS,
					finished: true,
				})
			);
			updateStats({
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			});
		}
	}, []);

	return (
		<div className="h-100">
			<div
				className="final-scene-root position-relative overflow-hidden"
				style={{
					minHeight: "100%",
					backgroundImage: `url(${finFelicidadesBg})`,
				}}
			>
				<div className="final-scene-copy text-center">
					<h1 className="final-scene-title mt-3">
						¡FELICIDADES! PROTOCOLO COMPLETADO
					</h1>
					<div className="final-scene-body">
						<p className="final-scene-line">
							Decisiones validadas con base en la evidencia de forma exitosa.
						<br/>
							Gracias por formar parte de ONCONEXT Patient Room.
						<br/>
							Pueden consultar su puntuación final a continuación.
						</p>
					</div>
				</div>
				<div
					className="px-5 final-scene-actions"
				>
					<NextButton
						text={"VER RESULTADOS"}
						navigateTo={ROUTES.RESULTS}
					/>
				</div>
			</div>
		</div>
	);
}

export default injectIntl(Congratulations);
